import styled, { css } from 'styled-components';
import MuiButton from '@material-ui/core/Button';
import { darken } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import { kassimGreen } from '../../style/theme';

const bgrColorCss = (color) => css`
    background-color: ${color};

    &:hover {
        background-color: ${darken(color, 0.2)};
    }
`;

const frontColorCss = (color) => css`
    color: ${color};
`;

export const Button = styled(({ backgroundColor, frontColor, ...props }) => (
    <MuiButton variant="contained" size="small" {...props} />
))`
    ${(props) => props.backgroundColor && bgrColorCss(props.backgroundColor)}
    ${(props) => props.frontColor && frontColorCss(props.frontColor)}
`;

export const SaveButton = styled((props) => (
    <Button
        // color="primary"
        startIcon={<SaveIcon />}
        backgroundColor={kassimGreen}
        frontColor="white"
        {...props}
    />
))``;

export const DeleteButton = styled((props) => (
    <Button color="secondary" startIcon={<DeleteIcon />} {...props} />
))``;
